import React from 'react';
import { ButtonPrimaryArrowOnly } from '@creditas-ui/button';
import { DrawerCloseButton, DrawerHeader, DrawerBody, DrawerFooter } from '../Drawer';
import { ButtonBack } from '../ButtonBack';

export type StepProps = {
  children: React.ReactNode;
  helperText?: React.ReactNode;
  showBack?: boolean;
  isValid?: boolean;
  isLoading?: boolean;
  handleBack?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  handleSubmit?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
};

const StepLayout = ({
  children,
  helperText,
  showBack = true,
  isValid = false,
  isLoading = false,
  handleBack = (): void => {},
  handleSubmit = (): void => {},
}: StepProps): JSX.Element => {
  return (
    <>
      <DrawerHeader>
        {showBack ? <ButtonBack onClick={handleBack} /> : <div />}
        <DrawerCloseButton />
      </DrawerHeader>
      <DrawerBody>{children}</DrawerBody>
      <DrawerFooter>
        {helperText || <div />}
        {isValid && (
          <ButtonPrimaryArrowOnly
            data-testid="button-only"
            size="large"
            type="button"
            loading={isLoading}
            onClick={handleSubmit}
          />
        )}
      </DrawerFooter>
    </>
  );
};

export { StepLayout };
